import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'
import Article from '../views/Article.vue'
import About from '../views/About.vue'
import BibleSchool from '../views/BibleSchool.vue'
import Contact from '../views/Contact.vue'
import Events from '../views/Events.vue'
import Location from '../views/Location.vue'
import LocationDetail from '../views/LocationDetail.vue'
import Media from '../views/Media.vue'
import News from '../views/News.vue'
import SingleDetail from '../views/SingleDetail.vue'
import OnlineGiving from "../views/OnlineGiving";
import History from "../views/History";
import Founders from "../views/Founders";
import StatementOfFaith from "../views/StatementOfFaith";
import Beliefs from "../views/Beliefs";
import MenOfIntegrity from "../views/MenOfIntegrity";
import PraiseAndWorship from "../views/PraiseAndWorship";
import LadiesMinistry from "../views/LadiesMinistry";
import ChildMinistry from "../views/ChildMinistry";
import Youth from "../views/Youth";
import Missions from "../views/Missions";
import EGEA from "../views/Egea";
import EventsDetail from "../views/EventsDetail";
import AudioMedia from "../views/AudioMedia";
import VideoMedia from "../views/Videos";
import PageNotFound from "../views/PageNotFound";
import ComingSoon from "../views/ComingSoon";
import Copyright from "../views/Copyright";
import Disclaimer from "../views/Disclaimer";
import PrivacyPolicy from "../views/PrivacyPolicy";
import TermsOfUse from "../views/TermsOfUse";

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home
  },
  {
    path: '/article',
    name: 'Article',
    component: Article
  },
  {
    path: '/about',
    name: 'About',
    component: About
  },
  {
    path: '/bibleschool',
    name: 'BibleSchool',
    component: BibleSchool
    
  },
  {
    path: '/contact',
    name: 'Contact',
    component: Contact
    
  },
  {
    path: '/events',
    name: 'Events',
    component: Events,
    props: true
    
  },
  {
    path: '/location',
    name: 'Location',
    component: Location
    
  },
  {
    path: '/locationdetail',
    name: 'LocationDetail',
    component: LocationDetail
    
  },
   {
     path: '/media',
     name: 'Media',
     component: Media
    
  },
  {
    path: '/news',
    name: 'News',
    component: News
    
  },
  {
    path: '/singledetail/:id',
    name: 'SingleDetail',
    component: SingleDetail,
    props: true

  },
  {
    path: '/events/:id',
    name: 'EventsDetail',
    component: EventsDetail,
    props: true

  },
  {
   path: '/online-giving',
   name: 'OnlineGiving',
   component: OnlineGiving

  },
  {
    path: '/our-history',
    name: 'History',
    component: History
  },
  {
    path: '/our-founders',
    name: 'Founders',
    component: Founders
  },
  {
    path: '/statement-of-faith',
    name: 'StatementOfFaith',
    component: StatementOfFaith
  },
  {
    path: '/coming-soon',
    name: 'Beliefs',
    component: Beliefs
  },
  {
    path: '/men-of-integrity',
    name: 'MenOfIntegrity',
    component: MenOfIntegrity
  },
  {
    path: '/bible-school',
    name: 'BibleSchool',
    component: BibleSchool
  },
  {
    path: '/coming-soon',
    name: 'ComingSoon',
    component: ComingSoon
  },
  {
    path: '/praise-and-worship',
    name: 'PraiseAndWorship',
    component: PraiseAndWorship
  },
  {
    path: '/ladies-ministry',
    name: 'LadiesMinistry',
    component: LadiesMinistry
  },
  {
    path: '/children-ministry',
    name: 'ChildMinistry',
    component: ChildMinistry
  },
  {
    path: '/youth',
    name: 'Youth',
    component: Youth
  },
  {
    path: '/missions',
    name: 'Missions',
    component: Missions
  },
  {
    path: '/egea',
    name: 'EGEA',
    component: EGEA
  },
  {
    path: '/audio-media',
    name: 'AudioMedia',
    component: AudioMedia
  },
  {
    path: '*',
    name: '404',
    component: PageNotFound
  },
  {
    path: '/egea',
    name: 'VideoMedia',
    component: VideoMedia
  },
  {
    path: '/copyright',
    name: 'Copyright',
    component: Copyright
  },
  {
    path: '/disclaimer',
    name: 'Disclaimer',
    component: Disclaimer
  },
  {
    path: '/privacy-policy',
    name: 'PrivacyPolicy',
    component: PrivacyPolicy
  },
  {
    path: '/terms-of-use',
    name: 'TermsOfUse',
    component: TermsOfUse
  },
]

const router = new VueRouter({
  mode: 'history',
  base: '/',
  routes
})

export default router
